export const SET_ALBUM_PHOTO_BACKGROUND =
  'album-photo-backgrounds/SET_ALBUM_PHOTO_BACKGROUND';
export const RESET_ALBUM_PHOTO_BACKGROUNDS =
  'album-photo-backgrounds/RESET_ALBUM_PHOTO_BACKGROUNDS';

export const setAlbumPhotoBackground = ({ photoId, printBackgroundId }) => {
  return {
    type: SET_ALBUM_PHOTO_BACKGROUND,
    photoId,
    printBackgroundId,
  };
};

export const resetAlbumPhotoBackgrounds = () => {
  return { type: RESET_ALBUM_PHOTO_BACKGROUNDS };
};
